var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Tabs as MuiTabs, styled } from '@mui/material';
import Tab from '../Tab';
import Divider from '../Divider';
var BorderBottom = styled(Divider)({
    position: 'absolute',
    bottom: 0,
    width: '100%',
});
var Tabs = function (_a) {
    var tabs = _a.tabs, childrenProp = _a.children, TabProps = _a.TabProps, borderBottom = _a.borderBottom, TabsProps = __rest(_a, ["tabs", "children", "TabProps", "borderBottom"]);
    var children = childrenProp;
    if (children == null) {
        children = tabs === null || tabs === void 0 ? void 0 : tabs.map(function (tabProps) {
            return React.createElement(Tab, __assign({}, tabProps, TabProps));
        });
    }
    return (React.createElement(MuiTabs, __assign({}, TabsProps),
        children,
        borderBottom !== 'none' && React.createElement(BorderBottom, null)));
};
export default Tabs;
